
import React, { useState, useEffect } from "react";
import { connect } from 'react-redux';
import {  Link } from "react-router-dom";
import actions from '../../redux/actions';
import Layout from '../../layouts/Layout'
const Component = (props) => {
  // console.log(props);
  const [ lineId, setLineId] = useState(props.data && props.data.user?props.data.user.lineId:"");
  console.log('props.user >>', props.user)
  return  <div style={{padding:'100px'}}>

      <Link to="/"> กลับ </Link>

      {
        props.user?
        <div> user : {props.user.lineId}</div>
        :null
      }


      lineId :
      <input value={lineId} onChange={(e)=>{
        console.log(e.target.value);
        setLineId(e.target.value)
      }}/>

      <button onClick={()=>{
        props.setUser({ lineId:lineId, profile: { name:'asdasd' } })
      }}>setUser</button>
      <button onClick={()=>{
        props.clearUser({})
      }}>clearUser</button>
    </div>
};


const mapStateToProps = state => {
  return {
    ...state
  };
};

export default connect(mapStateToProps, actions)(Component);
